import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function DigitalFootprintAnalysis({ digitalFootprintAnalysis }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // const dummyData = [
  //   {
  //     competitor: "a",
  //     website_traffic_monthly: "b",
  //     social_media_presence: "c",
  //     seo_keyword_strength: "d",
  //     website_traffic_monthly_positive_insight: "b",
  //     website_traffic_monthly_negative_insight: "b",
  //     website_traffic_monthly_recent_development: "b",
  //     social_media_presence_positive_insight: "c",
  //     social_media_presence_negative_insight: "c",
  //     social_media_presence_recent_development: "c",
  //     seo_keyword_strength_positive_insight: "d",
  //     seo_keyword_strength_negative_insight: "d",
  //     seo_keyword_strength_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     website_traffic_monthly: "b",
  //     social_media_presence: "c",
  //     seo_keyword_strength: "d",
  //     website_traffic_monthly_positive_insight: "b",
  //     website_traffic_monthly_negative_insight: "b",
  //     website_traffic_monthly_recent_development: "b",
  //     social_media_presence_positive_insight: "c",
  //     social_media_presence_negative_insight: "c",
  //     social_media_presence_recent_development: "c",
  //     seo_keyword_strength_positive_insight: "d",
  //     seo_keyword_strength_negative_insight: "d",
  //     seo_keyword_strength_recent_development: "d",
  //   },
  //   {
  //     competitor: "a",
  //     website_traffic_monthly: "b",
  //     social_media_presence: "c",
  //     seo_keyword_strength: "d",
  //     website_traffic_monthly_positive_insight: "b",
  //     website_traffic_monthly_negative_insight: "b",
  //     website_traffic_monthly_recent_development: "b",
  //     social_media_presence_positive_insight: "c",
  //     social_media_presence_negative_insight: "c",
  //     social_media_presence_recent_development: "c",
  //     seo_keyword_strength_positive_insight: "d",
  //     seo_keyword_strength_negative_insight: "d",
  //     seo_keyword_strength_recent_development: "d",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(digitalFootprintAnalysis);
    setTabData(tableData);
  }, [digitalFootprintAnalysis]);

  const tableColumns = [
    // { key: "competitor", label: "Competitor" },
    { key: "website_traffic_monthly", label: "Website Traffic (Monthly)" },
    { key: "social_media_presence", label: "Social Media Presence" },
    { key: "seo_keyword_strength", label: "SEO/Keyword Strength" },
  ];

  return (
    <InsightTable
      title="Digital Footprint Analysis"
      subtitle="Evaluation of competitors’ digital visibility, SEO strength, and social media engagement in the healthcare supply landscape."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default DigitalFootprintAnalysis;
